<script setup lang="ts">
import he from 'he'

const localePath = useLocalePath()
const route = useRoute()
const { slug } = route.params

const { t } = useI18n()
const { getResourceUrl } = useResources()
const { trimDescription, addSuffix } = useMeta()

const { data: designer } = await useAsyncData(() =>
  createDesignersRepository()
    .getBySlug(slug)
    .catch(() => {
      navigateTo(localePath('designers'))
    })
)

if (designer.value?.translationOfNid) {
  await useTranslatedSlugs(designer.value?.translationOfNid)
}

const { defaultOgImage } = useOgImage()

useSeoMeta({
  title:
    addSuffix(he.decode(designer?.value?.title)) ??
    t('pages.designers.meta.title'),
  description:
    trimDescription(stripHtml(designer?.value?.description)) ??
    t('pages.index.meta.description'),
  ogImage: designer.value?.backgroundImage?.url ?? defaultOgImage,
})
</script>

<template>
  <main>
    <UiBanner :title="designer?.title" />
    <section class="container pt-16">
      <div class="flex flex-row flex-wrap items-center">
        <div class="mb-8 basis-full lg:basis-1/3 lg:pr-8 xl:basis-1/4">
          <figure class="mx-auto w-1/2 lg:w-full" style="aspect-ratio: 1 / 1">
            <img
              class="h-full w-full rounded-full object-cover object-center"
              loading="lazy"
              :src="
                getResourceUrl(designer?.thumbnailImage?.url + '/1200x1200/FIT')
              "
            />
          </figure>
        </div>
        <div
          class="content-designer basis-full lg:basis-2/3 xl:basis-3/4"
          v-html="designer?.description"
        />
      </div>
    </section>
    <section class="container py-16">
      <div class="px-8">
        <div>
          <h2 class="caption mb-8 text-center">
            {{ t('base.designers.productLines') }}
          </h2>
          <div class="flex flex-wrap">
            <ProductLinesProductLineCard
              v-for="productLine in designer?.productLines"
              :key="productLine.nid"
              class="mb-8 w-full px-2 md:w-1/2"
              :product-line="productLine"
              :product-images="productLine.productImages"
            />
          </div>
        </div>
      </div>
    </section>

    <NewsSubscribe class="bg-neutral-50" />
  </main>
</template>

<style>
.content-designer p {
  margin-bottom: 2rem;
}
</style>
